import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class MovieSlide {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.splide');

    this.slider = null;
    this.autoplayInterval = null;
    this.autoplayDelay = 4000; // 4秒間隔で自動再生（Lensは少し長めに設定）
    this.isAutoplayActive = true;
    
    this.option = {
      type: 'loop',
      // autoWidth: true,
      perPage: 1,
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      speed: 900,
      arrows: false,
      pagination: false,
      gap: `min(${40 / 16}rem, ${40 / 375 * 100}vw)`,
      padding: {
        right: `${75 / 375 * 100}vw`,
        left: `${120 / 375 * 100}vw`,
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          perPage: 3,
          gap: `min(${70 / 16}rem, ${70 / 1440 * 100}vw)`,
          padding: {
            right: `min(${279 / 16}rem, ${279 / 1440 * 100}vw)`,
            left: `min(${283 / 16}rem, ${283 / 1440 * 100}vw)`,
          }
        }
      }
    };

    this.init();
  }

  init() {
    this.slider = new Splide(this.dom.slider, this.option);
    this.slider.mount();
    this.setupAutoplay();
    this.setupEventListeners();
  }

  // 自動再生を開始
  startAutoplay() {
    if (!this.isAutoplayActive) return;
    
    this.autoplayInterval = setInterval(() => {
      if (this.slider && this.isAutoplayActive) {
        this.slider.go('+1');
      }
    }, this.autoplayDelay);
  }

  // 自動再生を停止
  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  // 自動再生を一時停止
  pauseAutoplay() {
    this.isAutoplayActive = false;
    this.stopAutoplay();
  }

  // 自動再生を再開
  resumeAutoplay() {
    this.isAutoplayActive = true;
    this.startAutoplay();
  }

  // 自動再生の初期設定
  setupAutoplay() {
    this.startAutoplay();
  }

  // イベントリスナーの設定
  setupEventListeners() {
    // ホバー時に自動再生を一時停止
    this.dom.el.addEventListener('mouseenter', () => {
      this.pauseAutoplay();
    });

    // ホバー解除時に自動再生を再開
    this.dom.el.addEventListener('mouseleave', () => {
      this.resumeAutoplay();
    });

    // ページが非表示になった時に自動再生を停止
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoplay();
      } else {
        this.resumeAutoplay();
      }
    });
  }

  // クリーンアップ
  destroy() {
    this.stopAutoplay();
    if (this.slider) {
      this.slider.destroy();
    }
  }
}

export default MovieSlide